import React, { useContext } from 'react';
import { Box, Button } from '@mui/material';
import { useModal } from '../../../../hooks/Modal';
import { ModalTitle, ModalText } from './styled';
import { DefaultCollectContext } from '../..';
import { usePickup } from '../../../../hooks/Pickup';

export const ModalRemoveDeclaration = () => {
  const { Modal, closeModal } = useModal();

  const {
    declarationFiles,
    setDeclarationFiles,
    removeDeclaration,
    setRemoveDeclaration,
    useForceUpdate,
    setHasAcceptResponsibilityTerms
  } = useContext(DefaultCollectContext);

  const forceUpdate = useForceUpdate();

  const handleRemove = () => {
    const indexFile = declarationFiles.findIndex(
      (file) => file.id === removeDeclaration
    );

    const newDeclarationFiles = [...declarationFiles];

    newDeclarationFiles.splice(indexFile, 1);

    setDeclarationFiles(newDeclarationFiles);

    newDeclarationFiles.length === 0 && setHasAcceptResponsibilityTerms(false);
    setRemoveDeclaration('');
    forceUpdate();
    closeModal();
  };

  return (
    <Modal>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 16
        }}
      >
        <ModalTitle>Atenção!</ModalTitle>

        <ModalText>
          Ao excluir o documento “Declaração”, um novo “Tipo de Documento
          Fiscal” deverá ser selecionado na solicitação. Deseja continuar?
        </ModalText>

        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: 32,
            marginTop: 16
          }}
        >
          <Button
            type="button"
            data-testid="rejectRemoveDeclarationModalButton"
            variant="contained"
            color="error"
            onClick={closeModal}
          >
            Não
          </Button>
          <Button
            type="button"
            data-testid="acceptRemoveDeclarationModalButton"
            variant="contained"
            onClick={handleRemove}
          >
            Sim
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
